<script>
/*    Imports    */
    import { onMount, onDestroy, createEventDispatcher } from 'svelte';
    import { APIrequestGET } from '../../js_libs/API_calls';
    import BlokNacitani from '../../BlokNacitani.svelte';
    import { shared_rezervacni_mista } from "./../../js_libs/SharedInformation.js";
    import { refreshTrigger, triggerRefresh } from './../../js_libs/SharedInformation.js';
    import { derived } from 'svelte/store';

/* Props komponenty KalendarMesic */

    export let VybranePocatecniDatum = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    export let VybraneKoncoveDatum = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    
    export let TerminyProDanyMesic = [];
    
    $: mesic = new Date(new Date(TerminyProDanyMesic[0]?.start_time).getFullYear(), new Date(TerminyProDanyMesic[0]?.start_time).getMonth(), 1);

    // export let VybraneRezervaceZakaznika = [];

/* Vlastnosti komponenty KalendarMesic */
    export let PrepinacVyberuData = 0;

    export let displayed = true;

    const dispatch = createEventDispatcher();

    // $: TerminyRezervaci = ZiskatTerminyRezervaci(mesic);

    // $: rezervacni_mista = derived($shared_rezervacni_mista.map((i, n) => {i.id, n.name}), x=>x )

    // let id = generateUUID();

    // let unsubscribe;
/* Funkce komponenty KalendarMesic */

    /* Při vytvoření komponenty */
    onMount(() => 
        {
            // unsubscribe = refreshTrigger.subscribe(async ({ from, tick }) => {
            //     if (from !== id) {
            //         console.log(`Instance ${id}: reaguje na změnu od ${from}`);
            //         // zde reakce (např. fetch, reset, redraw)

            //         AktualizujUzivateluvVyberTerminu(VybranePocatecniDatum, VybraneKoncoveDatum, await TerminyRezervaci)
            //     } else {
            //         console.log(`Instance ${id}: ignoruje vlastní změnu`);
            //     }
            // });
        }
    )

    /* Při odebírání komponenty */
    onDestroy(() =>
        {
            // unsubscribe();
        }
    )

    /**
     * Aktualizuje uživatelův výběr z aktuálně zobrazovaného měsíce
     * 
     * @param {Date} pocatecniDatum  - Datum počátku termínu vybrané uživatelem (od)
     * @param {Date} konecneDatum - Datum konce termínu vybrané uživatelem (do)
     * @param {Array<Object>} terminy - Pole, které obsahuje stažené termíny ze serveru pro možnost přidání těchto možností k uživatelovi
     */
    // function AktualizujUzivateluvVyberTerminu(pocatecniDatum, konecneDatum, terminy)
    // {
    //     // Filtr pro odvybrané prvky
    //     // VybraneRezervaceZakaznika = VybraneRezervaceZakaznika.filter((termin) =>
    //     //     {
    //     //         const startDate = new Date(termin.start_time);

    //     //         if(startDate.getTime() >= pocatecniDatum.getTime() && startDate.getTime() <= konecneDatum.getTime())
    //     //         {                    
    //     //             return true;
    //     //         }

    //     //         return false;
    //     //     }            
    //     // );        

    //     // Přidá termíny z možných, které jsou mezi vybrané mezi počátačním a konečným datumem
    //     const noveTerminy = terminy.filter((termin) => {
    //         const startDate = new Date(termin.start_time);
    //         if(startDate.getTime() >= pocatecniDatum.getTime() && startDate.getTime() <= konecneDatum.getTime())
    //         {
    //             // HERE OTHER FUCKING CHECKS
                
    //             return true;
    //         }

    //         return false;
    //     });  

    //     const existujiciStartTimes = new Set(VybraneRezervaceZakaznika.map(t => t.start_time));

    //     VybraneRezervaceZakaznika = [
    //         ...VybraneRezervaceZakaznika,
    //         ...noveTerminy.filter(t => !existujiciStartTimes.has(t.start_time))
    //     ];

    //     console.log("kompletni", VybraneRezervaceZakaznika)
    // }


    /**
     * Procedura pro změnu uživatelova výběru data v daném měsíci
     * 
     * @param {Date} HodnotaData Hodnota data, která se má nově nastavit
     * 
     * @returns {void} - Procedura
     */
    function ZmenVybraneDatum(HodnotaData) 
    {  
        // console.log("Změna data:", HodnotaData, VybranePocatecniDatum, VybraneKoncoveDatum);
        
        if(PrepinacVyberuData == 0) {
            VybranePocatecniDatum = new Date(HodnotaData);
            VybraneKoncoveDatum = new Date(HodnotaData);
        }
        else if (PrepinacVyberuData == 1) {
            VybraneKoncoveDatum = new Date(HodnotaData);
        }
        

        PrepinacVyberuData = (PrepinacVyberuData + 1) % 2;
        
        if(VybraneKoncoveDatum.getTime() < VybranePocatecniDatum.getTime())
        {
            let DocasneVybraneDatum = VybraneKoncoveDatum;
            VybraneKoncoveDatum = VybranePocatecniDatum;
            VybranePocatecniDatum = DocasneVybraneDatum;
        }

        // triggerRefresh(id);
    }

    /**
     * @todo Přidat funkci na získání informací o daném měsíci (await API)
     *  
     * Vytvoří array s iformacemi pro tlačítka 
     * + Primárně datum dne, které tlačítko vyjadřuje
     * + Kapacita pro daný den
     * + Využitá kapacita daného dne
     * + Zbývající kapacita daného dne v měsíci
     * 
     * @param {Date} prvniDenMesice - Označuje první den zobrazovaného měsíce
     * @param {Array<Object>} stavRezervaci - Stáhnuté rezervace z API
     * 
     * @returns {Array<Date>} - Vrátí pole se všemi dny v měsíci, nebo null pro offset daného dne v týdnu 
     */
    function ZiskatDnyVMesici(prvniDenMesice, stavRezervaci) 
    {
        const [rok, mesic] = [prvniDenMesice.getFullYear(), prvniDenMesice.getMonth()];

        const PrvniDen = new Date(rok, mesic, 1);
        const PosledniDen = new Date(rok, mesic + 1, 0);

        const Dny = [];

        // Začátek týdne pondělí
        let PrvniDenTydne = (PrvniDen.getDay() + 6) % 7;
        for (let i = 0; i < PrvniDenTydne; i++) 
        {
            // Přidá mezeru pro posunutí vykreslování
            Dny.push(null);
        }

        for (let den = 1; den <= PosledniDen.getDate(); den++) 
        {
            const d = new Date(rok, mesic, den);
            const r = stavRezervaci.find((el) => (el.start_time.startsWith(FormatovatDatumProAPI(d))));

            const data = 
            {
                datum : d,
                reserved_count : r.reserved_count,
                capacity : r.capacity
            }

            // Přidá aktivní možnost pro zobrazení dne
            Dny.push(data);
        }

        return Dny;
    }


    /**
     * @description Funkce vypočítá, zda je rok, měsíc a den u obou datumů stejný
     * 
     * @param {Date} date1 - první datum k porovnání
     * @param {Date} date2 - druhé datum k porovnání
     * 
     * @returns {Bool} true, pokud je rok, měsíc a den stejný u dvou dat
     */
    function JsouDataStejna(date1, date2) 
    {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }

    /**
     * @description Formátuje datum pro API v požadovaném formátu DD-MM-YYYY
     * 
     * @param {Date} datum - Datum, které se má formátovat pro API
     * 
     * @returns {String} - Formátované datum ve tvaru DD-MM-YYYY
     */
    function FormatovatDatumProAPI(datum) 
    {
        const dd = String(datum.getDate()).padStart(2, '0');
        const mm = String(datum.getMonth() + 1).padStart(2, '0');
        const yyyy = datum.getFullYear();
        const final = `${yyyy}-${mm}-${dd}`;
        // console.log("Formátované datum pro API:", final);

        return final;
    }

    /**
     * 
     */
    // function generateUUID() {
    //     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //         const r = Math.random() * 16 | 0;
    //         const v = c === 'x' ? r : (r & 0x3 | 0x8);
    //         return v.toString(16);
    //     });
    // }
</script>

<div class="kalendar-mesic" class:kalendar-mesic-mimo={!displayed}>
    <div class="label-mesic">
        {mesic.toLocaleString('cs-CZ', { month: 'long', year: 'numeric' })}
    </div>
    <div class="kalendar-mrizka">
        <div class="kalendar-dny-tydne">
            <span>Po</span>
            <span>Út</span>
            <span>St</span>
            <span>Čt</span>
            <span>Pá</span>
            <span>So</span>
            <span>Ne</span>
        </div>
        <!-- {#await TerminyRezervaci} -->
            <!-- <BlokNacitani height={"195px"} /> -->
        <!--  style height -->
        <!-- {:then terminy}  -->
            <div class="kalendar-dny-na-vyber">
                {#each ZiskatDnyVMesici(mesic, TerminyProDanyMesic) as den}
                    {#if den}
                        <button
                            data-value={FormatovatDatumProAPI(den?.datum)}
                            class:selected = {
                                JsouDataStejna(den?.datum, VybranePocatecniDatum) || JsouDataStejna(den?.datum, VybraneKoncoveDatum)
                            }                        
                            class:durationSelected = {
                                (den?.datum.getTime() > VybranePocatecniDatum.getTime() && den?.datum.getTime() < VybraneKoncoveDatum.getTime())
                            }
                            class:notBookable = {
                                (den?.datum.getTime() < new Date().getTime()) || den?.reserved_count >= den?.capacity
                            }
                            class:reducedCapacity = {
                                den?.reserved_count > 0 && den?.reserved_count < den?.capacity
                            }
                            disabled = {
                                (den?.datum.getTime() < new Date().getTime())
                            }
                            on:click|preventDefault = {
                                () => {
                                    ZmenVybraneDatum(den?.datum);
                                    dispatch("change");
                                    // AktualizujUzivateluvVyberTerminu(VybranePocatecniDatum, VybraneKoncoveDatum, terminy);
                                }
                            }
                        >{den?.datum?.getDate()}</button>
                    {:else}
                        <span class="prazdne" />
                    {/if}
                {/each}
            </div>
        <!-- {:catch chyba} -->
            <!-- {chyba} -->
        <!-- {/await} -->
    </div>
</div>

<style>
.kalendar-mesic 
{
    flex: 1;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 1em;
    box-shadow: 0 2px 8px #0001;
}
.label-mesic 
{
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.5em;
}
.kalendar-mrizka 
{
    display: flex;
    flex-direction: column;
}
.kalendar-dny-tydne 
{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    font-size: 0.9em;
    color: #888;
    margin-bottom: 0.3em;
}
.kalendar-dny-na-vyber 
{
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 0.2em;
}
.kalendar-dny-na-vyber button 
{
    /* background: #fff; */
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5em 0;
    cursor: pointer;
    transition: background 0.2s;
    /* user unable to highlight selected */
    user-select: none;
}
.kalendar-dny-na-vyber button.selected 
{
    background: #1976d2 !important;
    color: #fff;
    border-color: #1976d2;
}

.kalendar-dny-na-vyber button.durationSelected 
{
    background: #4181c0 !important;
    color: #fff;
    border-color: #4181c0 !important;
}

.kalendar-dny-na-vyber button.reducedCapacity 
{
    background: #bec041;
    color: #000;
    border-color: #bec041;
}

.kalendar-dny-na-vyber button.notBookable 
{
    background: #c05041 !important;
    color: #000;
    border-color: #c05041 !important;
}

.kalendar-dny-na-vyber button:disabled 
{
    background: #eee;
    color: #bbb;
    cursor: not-allowed;
}

.kalendar-mesic-mimo 
{
    display: none;
}
</style>